import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import GeneratePaymentLink from './generate-payment-link';
import PaymentLinksView from './payment-links-view';

export const LinksRoutes: RouteObject[] = [
  {
    path: '',
    children: [
      {
        path: '',
        element: <Navigate to="generacion" replace />,
      }, {
        path: 'generacion',
        element: <GeneratePaymentLink />,
      }, {
        path: 'consulta',
        element: <PaymentLinksView />,
      },
    ],
  },
];
